import {get} from "lodash";
import AppSettingController from "../../../Main/controller/AppSettingController";
import MarketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import {ReactComponent as DeleteIcon} from "../../assets/icons/delete.svg";
import {ReactComponent as EditIcon} from "./assets/img/edit.svg";
import {AnimatePresence, motion} from "framer-motion";
import ExtraCostsState from "./interface/ExtraCostsState";
import React from "react";
import ExtraCostsController from "./controller/ExtraCostsController";
import {useTranslation} from "react-i18next";

export default function ExtraCostsList({state, setState}: {
    state: ExtraCostsState,
    setState: React.Dispatch<React.SetStateAction<ExtraCostsState>>
}) {
    const {t, i18n} = useTranslation();
    const lang = i18n.language === 'ar-IQ' ? 'ar-IQ' : 'fa-IR';
    const setting = AppSettingController.getSetting() as MarketSettingLocalStorage;
    const controller = new ExtraCostsController(state, setState)

    if (!get(setting, "extraCosts", []).length)
        return null

    return (
        <AnimatePresence>
            <motion.section
                className="public-key-container"
                initial={{scaleY: 0, opacity: 0}}
                animate={{scaleY: 1, opacity: 1}}
                exit={{scaleY: 0, opacity: 0}}
                transition={{duration: 0.3, ease: "easeInOut"}}
                style={{originY: 0}}
            >
                <div className="extra-cost-list desk-list">
                    <div className={'desk-list-header'}>
                        <h3>{t("setting.extraCostsList")}</h3>
                    </div>
                    <div className="extra-cost-list-item desk-list-item">
                        {get(setting, "extraCosts", []).map((item: {
                            id: string,
                            extraCostsName: string,
                            extraCostsPercentage: string,
                            extraCostsPrice: string,
                            extraCostsPriceSeparator: string,
                            state: string,
                            type: string
                        }) => (
                            <div key={`${item.extraCostsName}-${item.id}`}
                                 className={`desk-item ${item.state !== 'active' ? "disabled" : ""}`}>
                                <div>
                                    <span/>
                                    <p>{item.extraCostsName} - {item.extraCostsPrice ? Number(item.extraCostsPrice).toLocaleString(lang) : "%" + item.extraCostsPercentage}</p>
                                </div>
                                <div>
                                    <EditIcon onClick={e => controller.editExtraCosts(item.id)}/>
                                    <DeleteIcon onClick={e => AppSettingController.deleteExtraCosts(item.id)}/>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </motion.section>
        </AnimatePresence>
    );
}